<div class="spinner">
    <mat-spinner diameter="30" color="accent" *ngIf="instrument?.introductionText === null"></mat-spinner>
</div>
<app-watermark [isPhonePortrait]="isPhonePortrait" *ngIf="isPreview"></app-watermark>

<div *ngIf="instrument?.introductionText !== null"
    [innerHTML]="instrument.introductionText  | replacePatientTerm : instrument.introduction.patientTerms! : patientTerm! | sanitizeHtml"
    class="intro" [ngClass]="{'is-phone-portrait': isPhonePortrait}"></div>
<mat-divider></mat-divider>
<div class="center centerTC">
    <mat-checkbox 
        data-test-id="termsAndConditionAcceptCheckBox" 
        class="example-margin" 
        [(ngModel)]="selected"
        i18n>I have read and accept HSO’s <button type="button" class="link"
            (click)="openTermsOfUse()">Terms of Use</button> and <button type="button" class="link"
            (click)="openPrivacyPolicy()">Privacy Notice.</button> I hereby authorize HSO and my organization to
        collect, use, disclose, reproduce and publish my survey responses in compliance with and for the purposes
        described above and in the <button type="button" class="link" (click)="openTermsOfUse()">Terms of Use</button>
        and <button type="button" class="link" (click)="openPrivacyPolicy()">Privacy Notice.</button></mat-checkbox>
</div>
<div class="center">
    <button [hidden]="isPhonePortrait" data-test-id="questionnaireBeginButton" mat-raised-button color="primary"
        [disabled]="!selected || instrument.introductionText == null" (click)="beginSurvey()"
        i18n="Start Questionnaire|User clicks Begin button to start the questionnaire@@beginQuestionnaireButton">BEGIN</button>
    <button [hidden]="!isPhonePortrait" class="button-size" data-test-id="questionnaireBeginButton" mat-raised-button
        color="primary" [disabled]="!selected || instrument.introductionText == null" (click)="beginSurvey()"
        i18n="Start Questionnaire|User clicks Begin button to start the questionnaire@@beginQuestionnaireButton">BEGIN</button>
</div>
